import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationUsaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationUsa,
);
